module.exports = __webpack_public_path__ + "static/img/skye.4e4745f4.png";